// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"70e23f31","707":"345da1bc","730":"98050d38","821":"c6c06435"}[chunkId] + ".chunk.js");